import { ICaseDecision } from "../../../caseDecisions/model/CaseDecision";
import CaseDecisionMapper from "../../../caseDecisions/service/CaseDecisionMapper";
import CaseDecisionParamMapper from "../../../caseDecisions/service/CaseDecisionParamMapper";
import GetAllResourceEntriesInteractor from "../../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../../common/Constants";

export default class GetInvalidatedCaseDecisionsInteractor {
  private resource: GetAllResourceEntriesInteractor<ICaseDecision>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseDecisionId: string) {
    return this.resource.execute(
      `${Constants.caseDecisionsPath}/${caseDecisionId}/invalidated`,
      CaseDecisionMapper,
      CaseDecisionParamMapper
    );
  }
}
